// Reads a published template's CURRENT targets back into the admin publish
// panels (Prebuilt Agents + Canvas Templates). Both publish routes REPLACE
// publishShops, so a form that starts empty silently un-shares the template
// from every account it was already published to.

// Mirror of server/services/cognitive-flows/shopKey.js#normalizeShopKey.
// publishShops is stored normalized, but GET /admin/stores returns the raw
// shopify_store_settings.shop, so the two only compare equal after this.
export const normalizeShopKey = (value) => String(value ?? '')
  .trim()
  .toLowerCase()
  .replace(/\.myshopify\.com$/i, '');

/**
 * `row` is the template's published row, or null when it is not published.
 * Returns `{ visibility: 'all' | 'stores', shops }` with each target mapped to
 * the store list's own key. A target matching no store is kept verbatim, so
 * re-publishing never drops it without the admin unticking it.
 */
export function currentPublishTargets(row, stores = []) {
  if (!row || row.publishVisibility !== 'stores') return { visibility: 'all', shops: [] };
  const byNorm = new Map(stores.map((st) => [normalizeShopKey(st.shopKey), st.shopKey]));
  const shops = (row.publishShops || []).map((key) => byNorm.get(normalizeShopKey(key)) ?? key);
  return { visibility: 'stores', shops: [...new Set(shops)] };
}

/** Target-store options for SearchableMultiSelect, plus any selected key the store list lacks. */
export function targetStoreOptions(stores = [], selected = []) {
  const options = stores.map((st) => ({ value: st.shopKey, label: st.name, hint: st.shopKey }));
  const known = new Set(stores.map((st) => st.shopKey));
  selected
    .filter((key) => !known.has(key))
    .forEach((key) => options.push({ value: key, label: key, hint: 'Not in the store list — it may have been removed' }));
  return options;
}
